import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { IframeModal } from '.';

interface PDFModalProps {
  fileUrl: string;
  fileDownload: string;
  fileLabel: string;
}

export const PDFModal = ({
  fileUrl,
  fileLabel,
  fileDownload,
}: PDFModalProps) => {
  const [open, setOpen] = useState(false);
  const [viewing, setViewing] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setViewing(false);
  };

  const handleView = () => {
    setViewing(true);

    setOpen(true);
  };

  const handleDownload = () => {
    // Trigger download
    const link = document.createElement('a');
    link.href = `/csos2/assets/${fileUrl}`;
    link.download = fileDownload;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    handleClose();
  };

  return (
    <div style={{ marginTop: '7px' }}>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        {fileLabel}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description">
        <DialogTitle id="dialog-title">Select an Action</DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            Would you like to view or download the PDF?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleView} color="primary">
            View PDF
          </Button>
          <Button onClick={handleDownload} color="primary" autoFocus>
            Download PDF
          </Button>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      {viewing && (
        <IframeModal open={open} onClose={handleClose} fileUrl={fileUrl} />
      )}
    </div>
  );
};
